import aoflModules from 'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min';
import includeAbTestsPermissions from 'readingiq-src/js/riq-js/ab-tests-service/index';

var storeService = aoflModules.store;
var objectUtils = aoflModules.objectUtils;

var state = function state($rootScope, cdnAssetService, accessControlService) {
  var NAMESPACE = 'profile';
  var ALIAS = 'profile';
  var mutations = {
    init: function init() {
      return {
        groupUuid: '',
        profileUuid: '',
        userUuid: '',
        inactive: '',
        profileDetails: {
          name: '',
          lastName: '',
          avatar: '',
          contactEmail: '',
          contactLanguage: '',
          profileGradeLevel: '',
          activeReadingLevel: '',
          activeReadingLevelType: ''
        },
        error_code: 0
      };
    },
    setUserProfile: function setUserProfile(_moduleState, _payload) {
      if (_payload && _payload.profileUuid) {
        localStorage.setItem('riqPrivateActiveProfileId', _payload.profileUuid);
      }
      return Object.assign({}, _moduleState, _payload);
    },
    setUserProfileDetails: function setUserProfileDetails(
      _moduleState,
      _payload
    ) {
      return Object.assign({}, _moduleState, {
        profileDetails: _payload
      });
    },
    updateProfileDetails: function updateProfileDetails(
      _moduleState,
      _payload
    ) {
      var details = Object.assign({}, _moduleState.profileDetails, _payload);
      return Object.assign({}, _moduleState, {profileDetails: details});
    },
    clearProfile: function clearProfile() {
      return {
        groupUuid: '',
        profileUuid: '',
        userUuid: '',
        inactive: '',
        profileDetails: {},
        error_code: 0
      };
    },
    error: function error(_moduleState, _payload) {
      return Object.assign({}, _moduleState, _payload);
    },
    addFeaturePermissions: function addFeaturePermissions(
      _moduleState,
      _payload
    ) {
      return {
        ..._moduleState,
        ...{
          $permissions: _moduleState.$permissions.concat(_payload)
        }
      };
    }
  };

  var decorators = [
    function getAvatarURL(_nextState) {
      var nextState = _nextState;
      var currentState = storeService.getState();

      var hasNoAvatarUrl =
        nextState[NAMESPACE].profileDetails &&
        nextState[NAMESPACE].profileDetails.avatar &&
        !nextState[NAMESPACE].profileDetails.avatarUrl;
      var hasAvatarChanged =
        nextState[NAMESPACE].profileDetails &&
        nextState[NAMESPACE].profileDetails.avatar &&
        currentState[NAMESPACE] &&
        currentState[NAMESPACE].profileDetails &&
        nextState[NAMESPACE].profileDetails.avatar !==
          currentState[NAMESPACE].profileDetails.avatar;

      if (hasNoAvatarUrl || hasAvatarChanged) {
        var decoratedProfile = Object.assign(
          {},
          nextState[NAMESPACE].profileDetails,
          {
            avatarUrl:
              $rootScope.cdnBaseUrl +
              cdnAssetService.getAvatarImagePath({
                avatarId: nextState[NAMESPACE].profileDetails.avatar
              })
          }
        );
        return objectUtils.deepAssign(nextState, NAMESPACE, {
          profileDetails: decoratedProfile
        });
      }
      return nextState;
    },
    function isGroupOwner(_nextState) {
      var nextState = _nextState;
      var currentState = storeService.getState();

      var hasGroupOrUser =
        nextState[NAMESPACE] && (nextState.group || nextState.user);
      var hasGroupOwnerChanged =
        nextState.group &&
        nextState.group.ownerUserUuid !== currentState.group.ownerUserUuid;
      var hasUserChanged =
        nextState.user &&
        nextState.user.userUuid !== currentState.user.userUuid;
      var hasGroupChanged = hasGroupOwnerChanged || hasUserChanged;
      var hasNoGroupOwner =
        nextState[NAMESPACE] &&
        !nextState[NAMESPACE].hasOwnProperty('isGroupOwner');

      if (hasGroupOrUser && (hasGroupChanged || hasNoGroupOwner)) {
        var isGroupOwner = false;
        if (nextState.group && nextState.group.ownerUserUuid) {
          isGroupOwner =
            nextState.group.ownerUserUuid === nextState[NAMESPACE].userUuid;
        } else if (nextState.user && nextState.user.userUuid) {
          isGroupOwner =
            nextState.user.userUuid === nextState[NAMESPACE].userUuid;
        }
        return objectUtils.deepAssign(nextState, NAMESPACE, {
          isGroupOwner: isGroupOwner
        });
      }
      return nextState;
    },

    function setRole(_nextState) {
      const nextState = _nextState;
      const currentState = storeService.getState();

      if (_nextState.profile !== currentState.profile) {
        const $role = accessControlService.getMappedUserRole(_nextState);
        return objectUtils.deepAssign(nextState, NAMESPACE, {
          $role
        });
      }
      return nextState;
    },
    function setPermissions(_nextState) {
      const state = storeService.getState();
      // const $role = nextState.profile.$role;
      if (state.profile === _nextState.profile) {
        return _nextState;
      }
      let $permissions = accessControlService.getRolePermissions(
        _nextState.profile.$role
      );
      // FixME! We need clean permissions when there is no user. maybe a guest.
      if (_nextState.user.userUuid === _nextState.profile.userUuid) {
        $permissions = includeAbTestsPermissions(
          _nextState.user.componentsOverride,
          $permissions
        );
      }
      return objectUtils.deepAssign(_nextState, NAMESPACE, {
        $permissions
      });
    },

    function concatFeaturesToPermissions(_nextState) {
      // const state = storeService.getState();
      if (
        Array.isArray(_nextState.profile.$permissions) &&
        Array.isArray(_nextState.feature.permissionList)
      ) {
        const $permissions = _nextState.profile.$permissions.concat(
          _nextState.feature.permissionList
        );
        return objectUtils.deepAssign(_nextState, NAMESPACE, {
          $permissions: $permissions
        });
      }
      return _nextState;
    }
  ];

  return {
    namespace: NAMESPACE,
    alias: ALIAS,
    mutations: mutations,
    decorators: decorators
  };
};
export default state;
